import React, { useState } from "react";
import { FormatDate, FormatInt } from "../../utils/FormatData";
import { Badge, Button, Col, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import ModalEdit from "../../components/ModalEdit";
import CampaignEdit from "../../components/CampaignEdit";
import * as AiIcons from "react-icons/ai";
import { useAuth } from "../../Context/AuthContext";
import { httpClient } from "../../utils/HttpClient";
import { useQuery } from "@tanstack/react-query";
import TableSkeleton from "../../components/ui/Skeleton/TableSkeleton";
import { Table } from "../../components/ui/Table";

const CampaignsAdmin = () => {
  const Auth = useAuth();
  const { token } = Auth.getSessionData();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const columns = [
    {
      accessor: "vc_partnername",
      Header: "Partner",
    },
    {
      accessor: "vc_campaignname",
      Header: "Nombre",
    },
    {
      accessor: "vc_databasename",
      Header: "Grupo de Contactos",
    },
    {
      accessor: "i_records",
      Header: "Contactos",
      Cell: (rowData) => {
        let rowInfo = rowData.row.original;
        return (
          <Col style={{ textAlign: "center" }}>
            {FormatInt(rowInfo.i_records)}
          </Col>
        );
      },
    },
    {
      accessor: "tst_create",
      Header: "Ult. Mensaje",
      Cell: (rowData) => {
        let create = rowData.row.original.tst_create;
        return <>{FormatDate(create)}</>;
      },
    },
    {
      accessor: "i_programmed",
      Header: "Progr.",
      Cell: (rowData) => {
        let rowInfo = rowData.row.original;
        return (
          <Col style={{ textAlign: "center" }}>{rowInfo.i_programmed}</Col>
        );
      },
    },
    {
      accessor: "i_process",
      Header: "En Proceso",
      Cell: (rowData) => {
        let rowInfo = rowData.row.original;
        return <Col style={{ textAlign: "center" }}>{rowInfo.i_process}</Col>;
      },
    },
    {
      accessor: "i_finished",
      Header: "Enviados",
      Cell: (rowData) => {
        let rowInfo = rowData.row.original;
        return <Col style={{ textAlign: "center" }}>{rowInfo.i_finished}</Col>;
      },
    },
    {
      accessor: "i_canceled",
      Header: "Canc.",
      Cell: (rowData) => {
        let rowInfo = rowData.row.original;
        return <Col style={{ textAlign: "center" }}>{rowInfo.i_canceled}</Col>;
      },
    },
    {
      accessor: "i_total",
      Header: "Mensajes",
      Cell: (rowData) => {
        let rowInfo = rowData.row.original;
        return <Col style={{ textAlign: "center" }}>{rowInfo.i_total}</Col>;
      },
    },
    {
      accessor: "i_canceled1",
      Header: "Estatus",
      Cell: (rowData) => {
        let rowDataItem = rowData.row.original;
        return (
          <div style={{ textAlign: "right" }}>
            {rowDataItem.i_canceled == rowDataItem.i_total ? (
              <Badge bg="dark">Inactivo</Badge>
            ) : (
              ""
            )}
            {rowDataItem.i_programmed > 0 ? (
              <Badge bg="info">Programada</Badge>
            ) : rowDataItem.i_process > 0 ? (
              <Badge bg="warning">En Proceso</Badge>
            ) : (
              ""
            )}

            {rowDataItem.i_finished == rowDataItem.i_total ? (
              <Badge bg="success">Concluida</Badge>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      accessor: "none",
      Header: "Acciones",
      disableSortBy: true,
      headerProps: {
        className: "text-center",
      },
      cellProps: {
        className: "text-center",
      },
      Cell: (rowData) => {
        let uiddatabase = rowData.row.original.uid_campaigns;
        return (
          <>
            <Link to={"/Campaign/Details/" + uiddatabase}>
              <AiIcons.AiOutlineSearch
                className="IconTable"
                title="Detalles"
                onClick={""}
              />
            </Link>
          </>
        );
      },
    },
  ];

  const { data: listCampaigns, isPending } = useQuery({
    queryKey: ["CampaignsAdmin"],
    queryFn: async () => {
      const URI = ApiEndpoint + "configuration/getCampaigns/";

      const response = await httpClient("GET", URI, {}, token);

      return response.data;
    },
  });

  const renderTable = () => {
    if (isPending) {
      return <TableSkeleton />;
    }

    return (
      <div className="w-full bg-white rounded-lg px-4 py-2">
        <Table
          columns={columns}
          data={listCampaigns}
          config={{
            search: true,
            pagination: true,
            pageSize: 10,
            perPage: 10,
            footer: true,
          }}
        />
      </div>
    );
  };
  return (
    <>
      <div className="">
        <Stack direction="horizontal" gap={2}>
          <div>
            <h2>Campañas</h2>
            <h3>Administre los grupos de campañas.</h3>
          </div>
          <div className="ms-auto">
            {/* <Link to="/Administration/NewCampaignAdmin">
              <Button variant="outline-primary" size="sm">
                <AiIcons.AiOutlinePlus /> Agregar
              </Button>{" "}
            </Link>{" "}
            <Link to="/Administration/NewCampaignAdminV2">
              <Button variant="outline-primary" size="sm">
                <AiIcons.AiOutlinePlus /> Agregar V2
              </Button>{" "}
            </Link>{" "} */}
             <Link to="/Administration/NewCampaignAdminV2">
              <Button variant="primary" size="sm">
                <AiIcons.AiOutlinePlus /> Agregar 
              </Button>{" "}
            </Link>{" "}
            {/* <DropDownCustom
              title="Agregar"
              bodyTitle={"Agregar Campaña"}
              options={[
                {
                  label: "Agregar V1 (antiguo)",
                  icon: "add",
                  key: "old",
                },
                {
                  label: "Agregar V2",
                  icon: "add",
                  key: "new",
                },
              ]}
              onChange={(value) => {
                if (value.key === "old") {
                  navigate("/Administration/NewCampaignAdmin");
                }

                if (value.key === "new") {
                  navigate("/Administration/NewCampaignAdminV2");
                }
              }}
            /> */}
          </div>
        </Stack>

        {renderTable()}
      </div>
      <ModalEdit
        show={show}
        handleShow={handleShow}
        handleClose={handleClose}
        title="Editando Campaña"
      >
        <CampaignEdit />
      </ModalEdit>
    </>
  );
};

export default CampaignsAdmin;
